"use strict";!function(e){if(e&&"undefined"!=typeof window){var t=document.createElement("style");t.setAttribute("type","text/css"),t.innerHTML=e,document.head.appendChild(t)}}(".card {\n  border-radius: 10px;\n  border: 3px solid;\n}");
//# sourceMappingURL=Card.scss.js.map
